import React from "react";
import { Dialog, Typography, Button, DialogTitle, Divider, DialogActions, DialogContent } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
    container: {
        width: 600,
        padding: theme.spacing(1),
    },
    dialogActions: {
        marginTop: 10,
    },
}));

export function UserDeleteModal({ open, onCancel, onDelete }) {
    const classes = useStyles();
    return (
        <Dialog open={open} PaperProps={{ elevation: 4 }}>
            <div className={classes.container}>
                <DialogTitle>Delete User</DialogTitle>
                <Divider variant="middle" />
                <DialogContent>
                    <Typography variant="body2" color="textPrimary">
                        Deleting users cannot be undone and you will lose all of their account data and will not be able
                        to revoke their access using the same email address.
                    </Typography>
                    <br />
                    <Typography variant="body2" color="textPrimary" display="inline">
                        Are you sure you want to permanently delete the user?
                    </Typography>
                </DialogContent>
                <DialogActions className={classes.dialogActions}>
                    <Button color="primary" variant="outlined" onClick={() => onCancel()} disableElevation>
                        Cancel
                    </Button>
                    <Button onClick={() => onDelete()} color="primary" variant="contained">
                        Delete
                    </Button>
                </DialogActions>
            </div>
        </Dialog>
    );
}
